module.exports = __webpack_public_path__ + "img/doctor-holding-cash.5ba7c6be.jpg";